/* PDP Mix & Match slider — fills the empty <product-content-slider> shell that
   sections/mix-and-match-slider.liquid renders above the "View more" slider.

   The shell ships with no cards on purpose: the PDP has already spent its 20
   all_products[handle] lookups (12 colour swatches + 8 Complete the look), so the
   handles arrive as a data attribute and the cards come from products-by-handle —
   a separate render with its own budget. Same pattern as the swatch overflow
   (0-product-content.js) and the M&M popup overflow (custom-dialog.js).

   Runs once, on the product page only, and removes its own section whenever the
   slider should not be there. */
(function () {
  const HOST_SELECTOR = '[data-mm-slider]';

  /* Handles already rendered elsewhere on the page. Both card variants expose
     data-handle on their root (product-card.liquid). */
  function handlesIn(selector) {
    const found = new Set();
    document.querySelectorAll(selector).forEach((el) => {
      if (el.dataset.handle) found.add(el.dataset.handle);
    });
    return found;
  }

  /* The View more slider OVER-renders: with hide_low_availability on, Liquid emits up
     to 50 cards and product-slider.js#filterSort() then REMOVES the low-availability
     ones and everything past data-max-items. Reading its track before that runs would
     exclude products the shopper never actually sees there, so wait for the custom
     element to be defined (upgrades, and therefore filterSort, run synchronously at
     definition) plus one frame.

     product-slider.js is a deferred script, so it always defines before window load.
     Racing against load is therefore a safety net for the script being absent or
     failing outright — never something that can fire early on a slow page and send us
     back to reading the un-trimmed track. */
  function relatedSliderSettled() {
    const nextFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));
    // Already loaded: every deferred script has run, so filterSort is done either way.
    if (document.readyState === 'complete') return nextFrame();
    const defined = customElements.whenDefined('product-content-slider').then(nextFrame);
    const loaded = new Promise((resolve) => {
      window.addEventListener('load', resolve, { once: true });
    }).then(nextFrame);
    return Promise.race([defined, loaded]);
  }

  async function init() {
    const host = document.querySelector(HOST_SELECTOR);
    if (!host) return;

    const drop = () => host.remove();

    /* Gate: show ONLY when the info block actually rendered Complete the Look.
       data-mm-look-mode is emitted by snippets/mix-and-match-popup.liquid and is
       'true' only when a curated handle resolved to an available product — so a
       Mix & Match-only product (where the info block already shows these same
       products) never gets the slider too. */
    if (!document.querySelector('[data-mm-look-mode="true"]')) return drop();

    const handles = (host.dataset.handles || '')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);
    if (!handles.length) return drop();

    await relatedSliderSettled();

    const shown = handlesIn('.complete-the-look__wrapper [data-handle]');
    handlesIn('.related-products-slider-section [data-slider-track] [data-handle]').forEach(
      (handle) => shown.add(handle)
    );

    const wanted = [...new Set(handles)].filter((handle) => !shown.has(handle));
    if (!wanted.length) return drop();

    const api = window.ProductsByHandle;
    if (!api || typeof api.fetchCardsByHandle !== 'function') return drop();

    let cards = [];
    try {
      cards = await api.fetchCardsByHandle(wanted, 'slider');
    } catch (e) {
      cards = [];
    }
    if (!cards.length) return drop();

    const track = host.querySelector('[data-slider-track]');
    if (!track) return drop();

    const slider = host.querySelector('product-content-slider');
    const max = Number(slider && slider.dataset.maxItems) || cards.length;

    /* Unhide BEFORE injecting: product-slider.js re-measures arrows and the progress
       bar from its data-observe-track MutationObserver as soon as the track changes,
       and those measurements are all zero while an ancestor is display:none. */
    host.hidden = false;

    // The cards already carry .slider__item — products-by-handle's 'slider' context
    // renders them with item_class: 'slider__item'.
    track.append(...cards.slice(0, max));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
